export default __webpack_public_path__ + "static/media/landing_logo.9378f9ea.svg";